import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import ProfileScreen from '../screens/Profile/ProfileScreen';
import ContactUsScreen from '../screens/Profile/ContactUsScreen';
import EditProfileScreen from '../screens/Profile/EditProfileScreen';
import SettingsScreen from '../screens/Profile/SettingsScreen';
import AboutMentoristScreen from '../screens/Profile/AboutMentoristScreen';

export type ProfileStackParamList = {
  ProfileHome: undefined;
  ContactUs: { 
    category?: 'bug' | 'feature' | 'support' | 'content' | 'other';
    subject?: string;
    message?: string;
  } | undefined;
  EditProfile: undefined;
  Settings: undefined;
  AboutMentorist: undefined;
};

const Stack = createNativeStackNavigator<ProfileStackParamList>();

const ProfileStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="ProfileHome" component={ProfileScreen} />
      <Stack.Screen name="ContactUs" component={ContactUsScreen} />
      <Stack.Screen name="EditProfile" component={EditProfileScreen} />
      <Stack.Screen name="Settings" component={SettingsScreen} />
      <Stack.Screen name="AboutMentorist" component={AboutMentoristScreen} />
    </Stack.Navigator>
  );
};

export default ProfileStackNavigator;


